
import { ArtworksRecord } from '@/dataTypes/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    artwork: {
      type: Object as PropType<ArtworksRecord>,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    duplicateArtwork(artwork: ArtworksRecord) {
      this.$emit('duplicate', artwork.id);
    },
    displayArtworkImages(id: number) {
      this.$emit('display-images', id);
    },
    moveUp() {
      this.$emit('moveUp', this.artwork.id);
    },
    moveDown() {
      this.$emit('moveDown', this.artwork.id);
    },
  },
});
